import React, { useContext } from "react"
import FieldErrors from "../shared/field_errors"
import { BinaryFormContext, SIGNING_STATE_ALL } from "./models"

interface SigningStateSelectProps {
  name: string
  selected: string[]
  errors?: string[]
  onChange: (state: string, isSelected: boolean) => void
}

export default function SigningStateSelect({
  name,
  selected,
  errors,
  onChange,
}: SigningStateSelectProps) {
  const { disabled, signingStateOptions } = useContext(BinaryFormContext)
  const allSelected = selected.includes(SIGNING_STATE_ALL)
  const labelId = `${name}-label`
  const errorId = errors?.length ? `${name}-error` : undefined

  return (
    <div
      role="group"
      aria-labelledby={labelId}
      aria-describedby={errorId}
      className={
        errors?.length
          ? "binary-rule-signing-states has-error"
          : "binary-rule-signing-states"
      }
    >
      <span id={labelId} className="binary-rule-and">
        limited to signing state
      </span>

      {signingStateOptions.map(state => (
        <label className="checkbox-inline" key={state}>
          <input
            type="checkbox"
            name={`${name}[]`}
            value={state}
            checked={selected.includes(state)}
            disabled={disabled || (allSelected && state !== SIGNING_STATE_ALL)}
            onChange={event => onChange(state, event.target.checked)}
          />
          {state}
        </label>
      ))}

      <FieldErrors errors={errors} id={errorId} />
    </div>
  )
}
